import SingleSelectDropdown from '@precis-digital/kurama/SingleSelectDropdown'
import { type ReactElement } from 'react'
import { useCopilot, useSurfaceAgent } from 'shared/context/CopilotContext'
import { COPILOT_AGENT_NAMES, IS_AGENT_SWITCHER_ENABLED, isCopilotAgentName } from 'shared/copilot/copilotSurfaces'

const AGENT_OPTIONS = COPILOT_AGENT_NAMES.map((name) => ({ value: name, label: name }))

/** Dev/staging-only picker for the agent new chats on this surface start on. */
const CopilotAgentSwitcher = ({ onSwitch }: { onSwitch: () => void }): ReactElement => {
  const { agentName, preferredAgentName, setPreferredAgentName } = useSurfaceAgent()
  const { stopGeneration } = useCopilot()

  return (
    <SingleSelectDropdown
      title="Agent (dev only)"
      options={AGENT_OPTIONS}
      value={agentName}
      buttonWidth="160px"
      onSelect={(value) => {
        if (!isCopilotAgentName(value) || (value === agentName && value === preferredAgentName)) {
          return
        }
        stopGeneration()
        setPreferredAgentName(value)
        onSwitch()
      }}
    />
  )
}

// Production renders nothing and skips the context subscriptions.
export default IS_AGENT_SWITCHER_ENABLED ? CopilotAgentSwitcher : (): null => null
